import React, { useEffect } from 'react';
import { Form } from 'antd';
import { observer } from 'mobx-react';
import { DEFAULT_AVATAR } from '@gtintel/platform-constants';
import { user } from '@gtintel/platform-mocks';
import { useStores } from '@gtintel/platform-stores';
import ClientCard from '../ClientCard';
import styles from './style.module.scss';
const ClientState = props => {
  const {
    authStore
  } = useStores();
  const {
    project
  } = props;
  useEffect(() => {
    if (user) {
      authStore.getAuthUsers();
    }
  }, [authStore]);
  return <Form.Item label={project?.client?.team_name} labelAlign="left" className={styles.clientCardWrap}>
      <a href={`/admin/user/detail?id=${project?.client?.id}`}>
        <ClientCard avatar={project?.client?.avatar ?? DEFAULT_AVATAR} name={project?.client?.first_name} lastname={project?.client?.last_name} />
      </a>
    </Form.Item>;
};
export default observer(ClientState);